import { JSONContent } from "@tiptap/react";
import create from 'zustand';
import { persist } from 'zustand/middleware'

type OutputData = JSONContent;
const DEFAULT_SAVE: OutputData = {
  type: "doc",
  content: [
    {
      type: "heading",
      attrs: { "level": 2 },
      content: [{ type: "text", text: "✍️ Scratchpad" }]
    }]
}

const STRINGIFIED_SAVE = JSON.stringify(DEFAULT_SAVE);

export function load(): OutputData {
  return JSON.parse(localStorage.getItem('blocks') || STRINGIFIED_SAVE)
};

export function save(blocks: OutputData) {
  localStorage.setItem('blocks', JSON.stringify(blocks));
};

// zustand related
interface SettingsState {
  isDarkmode: boolean,
  toggleTheme: () => void,
  showVisualization: boolean,
  toggleVisualization: () => void,
  enableFadeIn: boolean,
  toggleFadeIn: () => void,
  enableTaskAnimation: boolean,
  toggleTaskAnimation: () => void,
}

export function loadDefault() {
  return window.matchMedia('(prefers-color-scheme: light)').matches ? 'light' : 'dark'
}

export const useSettingsStore = create<SettingsState>()(persist(
  (set, get) => ({
    isDarkmode: loadDefault() === 'dark',
    toggleTheme: () => set({ isDarkmode: get().isDarkmode ? false : true }),
    showVisualization: true,
    toggleVisualization: () => set({ showVisualization: !get().showVisualization }),
    enableFadeIn: true,
    toggleFadeIn: () => set({ enableFadeIn: !get().enableFadeIn }),
    enableTaskAnimation: true,
    toggleTaskAnimation: () => set({ enableTaskAnimation: !get().enableTaskAnimation }),
  }),
  {
    version: 1,
    name: 'settings',
  }
))

